import { Controller } from "@hotwired/stimulus"
import { get }        from '@rails/request.js'
import TomSelect      from "tom-select"

/*
Implementa um par de selects com hierarquia.
O select "pai" (filter) deve possuir as opções diretamente no html. Da mesma forma, o valor inicialmente selecionado nele,
caso exista, deve ser informado no markup.
Já as opções do select "filho" (other) são buscadas via ajax. Para pré-selecionar um valor no filho, utilizar data-ts--filter-selected-other-value.
Ao selecionar um valor no primeiro select, faz uma chamada para a URL informada e utiliza os valores do retorno para
preencher as opções disponíveis no segundo select.

Exemplo de uso:

Na view:

  <div data-controller="ts--filter"
       data-ts--filter-url-value="<%= filter_atividades_path %>"
       data-ts--filter-selected-other-value="<%= @registro.atividade_id %>">

    <%= f.input :categoria_id, collection: @categorias, input_html: {data: {ts__filter_target: "filter"}} %>
    <%= f.input :atividade_id, collection: [], input_html: {data: {ts__filter_target: "other"}} %>

  </div>

No controller (retorna os valores a serem exibidos no filho com base na seleção realizada no pai, disponível no params[:filter]):

  def atividades
    @atividades = Atividade.where(categoria_id: params[:filter])
    render json: @atividades.map { |a| {text: a.nome, value: a.id} }
  end

*/

// Connects to data-controller="ts--filter"
export default class extends Controller {
  static targets = [ "filter", "other" ]
  static values  = {
    url: String,
    selectedOther: String
  }

  connect() {
    this.filterTarget.addEventListener('change', ev => {
      if(this.selectedFilter)
        this.fetchItems()
      else
        this.clearItems()
    })

    if (this.selectedFilter)
      this.fetchItems()
  }

  async fetchItems() {
    this.tomSelect.wrapper.classList.add("bg-primary", "bg-opacity-10")

    const response = await get(this.urlValue, {
      query: { filter: this.selectedFilter },
      responseKind: 'json'
    })

    if(response.ok)
      this.setItems(await response.json)
    else
      console.error(response)

    this.tomSelect.wrapper.classList.remove("bg-primary", "bg-opacity-10")
  }

  setItems(items) {
    this.clearItems()
    this.tomSelect.addOptions(items)
    this.tomSelect.refreshOptions(false)
    if (this.hasSelectedOtherValue)
      this.tomSelect.setValue(this.selectedOtherValue)
  }

  clearItems() {
    this.tomSelect.clear()
    this.tomSelect.clearOptions()
  }

  get selectedFilter() {
    return this.filterTarget.value
  }

  get tomSelect() {
    this._tomSelect ||= new TomSelect(this.otherTarget, {
      plugins: [ 'clear_button']
    })

    return this._tomSelect
  }

}

